import React, {PropTypes} from 'react';
/* import {Link} from 'react-router'; */
import {Modal} from 'reactstrap';
import {I18n} from 'react-redux-i18n';

class PageSetupModal extends React.Component
{
  constructor(props)
  {
    super(props);

    let posY = 0;
    let posX = 0;
    if(props.offsetValue !== null)
    {
      posY = props.offsetValue.PosY;
      posX = props.offsetValue.PosX;
    }

    this.state = {
      verticalOffset: posY,
      horizontalOffset: posX
    };
  }

  handleVerticalChange = (e) => {
    this.setState({verticalOffset: e.target.value});
  }

  handleHorizontalChange = (e) => {
    this.setState({horizontalOffset: e.target.value});
  }

  handleSave = () => {
    this.props.onAccept(this.state.verticalOffset, this.state.horizontalOffset);
  }

  handleVerticalSave = (e) => {
    this.props.onAccept(e.target.value, this.state.horizontalOffset);
  }

  handleHorizontalSave = (e) => {
    this.props.onAccept(this.state.verticalOffset, e.target.value);
  }

  render()
  {
    /* const {isOpen, onClose, calibrationLink} = this.props; */

    const {isOpen, onClose} = this.props;

    return (
      <Modal isOpen={isOpen} toggle={onClose} id="modalPageSetup" className="wide-modal">
        <div className="modal-header">
          <h4 className="modal-title" id="exampleModalLabel">{I18n.t('PRINTER_ADJUSTMENT')}</h4>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
            <span className="lnr lnr-cross" aria-hidden="true"/>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-sm-12">
          
              <div dangerouslySetInnerHTML={{ __html: I18n.t('ADJUSTMENT_INSTRUCTIONS')}}/>
              <br />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {I18n.t('B_HORIZONTAL')}
              <input className="form-control" type="number" value={this.state.horizontalOffset} id="example-text-input" 
                onChange={(e) => {this.handleHorizontalChange(e); this.handleHorizontalSave(e);}}/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {I18n.t('A_VERTICAL')}
              <input className="form-control" type="number" value={this.state.verticalOffset} id="example-text-input" 
                onChange={(e) => {this.handleVerticalChange(e); this.handleVerticalSave(e);}}/>
            </div>
          </div>


{/*           <div className="modal-footer">
            <Link to={calibrationLink} target="_blank" className="btn btn-primary">{I18n.t('PRINT_CALIBRATION_PAGE')}</Link>
          </div> */}
        </div>
      </Modal>
    );
  }
}
  
PageSetupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  offsetValue: PropTypes.object.isRequired
/*   ,
  calibrationLink: PropTypes.string.isRequired */
};

export default PageSetupModal;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/PageSetupModal.js
 **/